import classNames from 'classnames'
import React from 'react'
import Icon from '../icon'

type Size = 'sm' | 'md'

type Props = {
  collapsedTitle: string
  expandedTitle: string
  expanded: boolean
  onClick: (arg0: React.MouseEvent) => void
  size?: Size
  ariaControls: string
  noIconMargin?: boolean
  className?: string
}

export const ExpandButton = ({
  collapsedTitle,
  expandedTitle,
  expanded,
  onClick,
  size = 'md',
  ariaControls,
  noIconMargin = false,
  className = '',
}: Props) => {
  return (
    <button
      className={`button-stripped u-mb-0 ${className}`}
      aria-controls={ariaControls}
      aria-expanded={expanded}
      onClick={e => onClick(e)}>
      <Icon
        name={expanded ? 'arrow-up-small' : 'arrow-down-small'}
        className={classNames({
          'u-mr-4': !noIconMargin,
          'i-16': size === 'sm',
          'i-24': size === 'md',
        })}
      />
      <span
        className={classNames({
          'u-fs-12': size === 'sm',
          'u-fs-14': size === 'md',
        })}>
        {expanded ? expandedTitle : collapsedTitle}
      </span>
    </button>
  )
}

export default ExpandButton
